// Stops the body from overflowing (usually when a slide in is open)
export function setBodyOverflow(allowOverflow: boolean) {
  var element = document.getElementById('_site_body');

  if (element && allowOverflow) {
    element.style.overflow = 'initial';
  }
  if (element && !allowOverflow) {
    element.style.overflow = 'hidden';
  }
}
